import React, { useState, useEffect } from "react";
import { Dropdown,
    DefaultButton,
    PrimaryButton,
    Dialog,
    DialogType,
    Panel,
    PanelType,
    Toggle,
    SpinButton } from "@fluentui/react";
import Axios from "axios";
import { Icon } from "@fluentui/react/lib/Icon";
import "../../Styles/VTNETFrame.css";

const VTNETFrame = ({ setCurrentFrame, project }) => {
    const [currentTime, setCurrentTime] = useState("");
    const [panelNumber, setPanelNumber] = useState(project?.panel?.VT5000_CONFIG?.GeneralParameters?.vtnetNetworkPanelNb || 0);
    const [panelAddress, setPanelAddress] = useState(project?.panel?.VT5000_CONFIG?.GeneralParameters?.vtnetPanelAddress || 0);
    const [alarmVisible, setAlarmVisible] = useState(project?.panel?.VT5000_CONFIG?.GeneralParameters?.vtnetAlarmVisible);
    const [resetEnable, setResetEnable] = useState(project?.panel?.VT5000_CONFIG?.GeneralParameters?.vtnetResetEnable);
    const [evacEnable, setEvacEnable] = useState(project?.panel?.VT5000_CONFIG?.GeneralParameters?.vtnetEvacEnable);
    const [faultVisible, setFaultVisible] = useState(project?.panel?.VT5000_CONFIG?.GeneralParameters?.vtnetFaultVisible);
    const [isDevicesDialogOpen, setIsDevicesDialogOpen] = useState(false);
    const [loopPresent, setLoopPresent] = useState(0);
    const [panelType, setPanelType] = useState(0);
    const [selectedPanel, setSelectedPanel] = useState(0);

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            let formattedTime = now.toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).replace(/,/g, ""); // Remove comma between date and time

            formattedTime = formattedTime.replace(/(\d{4})\//, "$1 "); // Remove '/' after year
            setCurrentTime(formattedTime);
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, []);

    const handlePanelButtonClick = (index) => {
        setSelectedPanel(index);
        setLoopPresent(project.panel.VT5000_CONFIG.VTNet[index].loopNb);
        setPanelType(project.panel.VT5000_CONFIG.VTNet[index].panelType);
    }

    const handleSave = () => {
        if (project?.panel?.VT5000_CONFIG?.GeneralParameters) {
            project.panel.VT5000_CONFIG.GeneralParameters.vtnetNetworkPanelNb = panelNumber;
            project.panel.VT5000_CONFIG.GeneralParameters.vtnetPanelAddress = panelAddress;
            project.panel.VT5000_CONFIG.GeneralParameters.vtnetAlarmVisible = alarmVisible ? 1 : 0;
            project.panel.VT5000_CONFIG.GeneralParameters.vtnetEvacEnable = evacEnable ? 1 : 0;
            project.panel.VT5000_CONFIG.GeneralParameters.vtnetFaultVisible = faultVisible ? 1 : 0;
            project.panel.VT5000_CONFIG.GeneralParameters.vtnetResetEnable = resetEnable ? 1 : 0;

            const userEmail = localStorage.getItem('userEmail');
            Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_generalparameters`, {
                projectId: project.project_id,
                panelContentId: project.panel.VT5000_CONFIG.panelContent_id,
                generalparameters: project.panel.VT5000_CONFIG.GeneralParameters,
                email: userEmail,
            })
                .then((response) => {
                    if (response.data.success) {
                        console.log("VTNET in General Parmeters updated successfully");
                    } else {
                        console.error("Failed to update VTNET in General Parmeters");
                    }
                })
                .catch((error) => {
                    console.error("Error updating VTNET in General Parmeters:", error);
                });
        }
    };

    const handleSaveVTNET = () => {
        if (project?.panel?.VT5000_CONFIG?.VTNet) {
            project.panel.VT5000_CONFIG.VTNet[selectedPanel].loopNb = loopPresent;
            project.panel.VT5000_CONFIG.VTNet[selectedPanel].panelType = panelType;

            const userEmail = localStorage.getItem('userEmail');
            Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_vtnets`, {
                projectId: project.project_id,
                panelContentId: project.panel.VT5000_CONFIG.panelContent_id,
                vtnets: project.panel.VT5000_CONFIG.VTNet,
                email: userEmail,
            })
                .then((response) => {
                    if (response.data.success) {
                        console.log("VTNETs updated successfully");
                        setIsDevicesDialogOpen(false);
                    } else {
                        console.error("Failed to update VTNETs");
                    }
                })
                .catch((error) => {
                    console.error("Error updating VTNETs:", error);
                });
        }
    };

    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ fontSize: 40, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ textAlign: "left", flex: 1 }}>VT-NET</span>
                <span style={{ textAlign: "right", flex: 1 }}>{currentTime}</span>
            </div>
            <hr style={{ width: "100%", border: "1px solid black", margin: "5px 0" }} />

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", width: "80%" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Panels in Network</span>
                    <Dropdown
                        placeholder="Select Silence Duration"
                        options={Array.from({ length: 65 }, (_, i) => ({ key: i, text: i.toString() }))}
                        selectedKey={panelNumber}
                        onChange={(e, option) => {
                            setPanelNumber(option.key);
                            if (option.key > 0) {
                              setIsDevicesDialogOpen(true);
                            } else {
                              setIsDevicesDialogOpen(false);
                            }
                          }}
                        onRenderCaretDown={() => <Icon iconName="ChevronDown" styles={{ root: { fontSize: 20 } }} />} // Custom caret down icon
                        styles={{ dropdown: { width: 150 }, callout: { maxHeight: 200 } }}
                    />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Identifier</span>
                    <Dropdown
                        placeholder="Select Silence Duration"
                        options={Array.from({ length: panelNumber + 1 }, (_, i) => ({ key: i, text: i.toString() }))}
                        selectedKey={panelAddress}
                        onChange={(e, option) => setPanelAddress(option.key)}
                        onRenderCaretDown={() => <Icon iconName="ChevronDown" styles={{ root: { fontSize: 20 } }} />} // Custom caret down icon
                        styles={{ dropdown: { width: 150 }, callout: { maxHeight: 200 } }}
                    />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Reset Silence</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={resetEnable}
                            onChange={() => setResetEnable(!resetEnable)}
                            styles={{ pill: { background: resetEnable ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{resetEnable ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Evacuation</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={evacEnable}
                            onChange={() => setEvacEnable(!evacEnable)}
                            styles={{ pill: { background: evacEnable ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{evacEnable ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>View Alarms</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={alarmVisible}
                            onChange={() => setAlarmVisible(!alarmVisible)}
                            styles={{ pill: { background: alarmVisible ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{alarmVisible ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Faults</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={faultVisible}
                            onChange={() => setFaultVisible(!faultVisible)}
                            styles={{ pill: { background: faultVisible ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{faultVisible ? "Yes" : "No"}</span>
                    </div>
                </div>
            </div>

            <Dialog
                hidden={!isDevicesDialogOpen}
                onDismiss={() => setIsDevicesDialogOpen(false)}
                dialogContentProps={{
                    type: DialogType.normal,
                }}
                minWidth={"1000px"}
            >
                <div>
                    <div className="devices-content">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", width: "100%", marginTop: "10px" }}>
                            <span style={{ fontSize: "30px" }}>Model</span>
                            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                {[
                                    { label: "VT5000", value: 1 },
                                    { label: "Vita", value: 2 }
                                ].map(({ label, value }) => (
                                    <div
                                        key={label}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "150px",
                                            height: "60px",
                                            border: "2px solid black",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            background: panelType === value ? "#C00D0D" : "#FFF"
                                        }}
                                        onClick={() => setPanelType(panelType === value ? 0 : value)} // toggle logic
                                    >
                                        <span style={{
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            color: panelType === value ? "#FFF" : "#000"
                                        }}>
                                            {label}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                            <div className="loop-present-buttons">
                                <span>Loop Present:</span>
                                {Array.from({ length: 9 }, (_, index) => {
                                    const value = index + 1;
                                    const isSelected = loopPresent === value;

                                    return (
                                        <button
                                            key={index}
                                            className={`loop-present-button ${isSelected ? "selected-loop" : ""}`}
                                            onClick={() => setLoopPresent(isSelected ? 0 : value)}
                                        >
                                            {value}
                                        </button>
                                    );
                                })}
                            </div>
                            <div style={{ display: "flex", gap: "10px" }}>
                                <PrimaryButton text="Save" onClick={() => handleSaveVTNET()} />
                                <DefaultButton text="Back" onClick={() => setIsDevicesDialogOpen(false)} />
                            </div>
                        </div>
                        <div className="panel-buttons-container">
                            <div className="panel-buttons-frame">
                                {Array.from({ length: 64 }, (_, index) => {
                                    return (
                                        <button
                                            key={index}
                                            className={`panel-button ${(index < panelNumber && index + 1 !== panelAddress) ? "programmed" : "not-programmed"} ${(index === selectedPanel) ? "selected" : ""}`}
                                            disabled={index >= panelNumber || index + 1 === panelAddress}
                                            onClick={() => handlePanelButtonClick(index)}
                                        >
                                            <span>{index + 1}</span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <div style={{ display: "flex", width: "98%", justifyContent: "space-evenly", position: "absolute", bottom: "2%" }}>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 10% 0 0", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("main")}>Logout</button>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 1px 0 0", background: "none", borderRadius: "5px" }} onClick={handleSave}>Save</button>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 0px", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("additionalCards")}>Back</button>
            </div>
        </div>
    );
};

export default VTNETFrame;